<template>
  <div class="d-flex flex-column gap-12 mb-6">
    <!-- section 1 -->
    <divcard>
      <div class="txt-head black--text mb-2">
        <span class="theme-color-one">ส่วนที่ 2 :</span> วงเงินที่ได้รับอนุมัติ
        และสถานะการดำเนินโครงการ
      </div>
      <div class="txt-head black--text d-flex justify-space-between">
        <div>
          1.  วงเงินที่ได้รับอนุมัติและงบประมาณที่ใช้จ่ายจริง 
          <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
        </div>

        <Button
          v-if="!isFinal"
          theme="6"
          :disabled="partTwoEditMode"
          @onClick="addNewBudget"
        >
          + เพิ่มรายละเอียดงบประมาณ
        </Button>
      </div>

      <div class="card-part">
        <div class="d-flex theme-color-eight px-3 mb-3 gap-12">
          <div style="width: 8%">{{ isFinal ? "" : "จัดการ" }}</div>
          <div style="width: 20%">รายการ</div>
          <div style="width: 24%">รายละเอียด</div>
          <div class="text-end" style="width: 24%">ค่าใช้จ่ายจริง (บาท)</div>
          <div class="text-end" style="width: 24%">กรอบวงเงินงบประมาณ(บาท)</div>
        </div>

        <div class="d-flex flex-column gap-16">
          <div v-for="(item, i) in budgetList" :key="i" class="budget-item">
            <!--            :class="{ 'budget-item-active': item.expanded }"-->
            <div
              class="d-flex justify-space-between align-center black--text gap-12"
            >
              <div style="width: 8%">
                <v-btn v-if="!isFinal" small icon @click="editBudget(i)">
                  <Iconify
                    icon="material-symbols:edit"
                    color="var(--theme-color-seven)"
                  ></Iconify>
                </v-btn>
                <v-btn v-if="!isFinal" small icon @click="deleteBudget(i)">
                  <Iconify
                    icon="material-symbols:delete"
                    color="var(--theme-color-seven)"
                  ></Iconify>
                </v-btn>
              </div>
              <div style="width:20%">
                {{ item.budget_name }}
              </div>
              <div style="width: 24%">
                <div style="min-height: 22px; max-height: 22px"></div>
                <div>
                  <div
                    v-for="(detail, ind) in item.form_fund_budget_detail"
                    :key="ind"
                    class="theme-color-eight"
                  >
                    {{ ind + 1 }}. {{ detail.budget_detail_name }}
                  </div>
                </div>
              </div>
              <div class="text-end" style="width: 24%">
                {{ formatNumber(item.actual_amount, 2) }} บาท
                <div>
                  <div
                    v-for="(detail, ind) in item.form_fund_budget_detail"
                    :key="ind"
                    class="text-end theme-color-eight"
                  >
                    {{ formatNumber(detail.actual_detail_amount, 2) }} บาท
                  </div>
                </div>
              </div>
              <div class="text-end" style="width: 24%">
                {{ formatNumber(item.budget_amount_rsp, 2) }} บาท
                <div>
                  <div
                    v-for="(detail, ind) in item.form_fund_budget_detail"
                    :key="ind"
                    class="text-end theme-color-eight"
                  >
                    {{ formatNumber(detail.budget_detail_amount, 2) }} บาท
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex flex-column gap-12 px-12 my-5">
          <div class="d-flex justify-space-between">
            <div class="black--text">รวมวงเงินงบประมาณ</div>
            <div>
              {{
                formatNumber(
                  budgetList
                    .map((x) => parseFloat(x.budget_amount_rsp))
                    .reduce((a, b) => a + b, 0),
                  2
                )
              }}
              บาท
            </div>
          </div>
        </div>
        <div class="d-flex flex-column gap-12 px-12 my-5">
          <div class="d-flex justify-space-between">
            <div class="black--text">รวมค่าใช้จ่ายต่อเดือน</div>
            <div>
              {{
                formatNumber(
                  budgetList
                    .map((x) => parseFloat(x.actual_amount))
                    .reduce((a, b) => a + b, 0),
                  2
                )
              }}
              บาท
            </div>
          </div>
        </div>
        <div class="d-flex flex-column gap-12 px-12 my-5">
          <div class="d-flex justify-space-between">
            <div class="black--text">คงเหลือ</div>
            <div class="theme-color-one">
              {{
              formatNumber(
                budgetList
                  .map((x) => parseFloat(x.budget_amount_rsp))
                  .reduce((a, b) => a + b, 0)
                -
                budgetList
                  .map((x) => parseFloat(x.actual_amount))
                  .reduce((a, b) => a + b, 0),
                2
              )
            }}
              บาท
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="partTwoEditMode && !isFinal"
        id="part-two-edit"
        class="card-part"
      >
        <div class="d-flex gap-16 mb-3">
          <div>
            <div class="black--text mb-3">รายการ</div>

            <TextField
              theme="3"
              style="width: 400px"
              :value="tempBudget.budget_name"
              @onChange="tempBudget.budget_name = $event"
            ></TextField>
          </div>

          <div>
            <div class="black--text mb-3">ค่าใช้จ่ายจริง (บาท)</div>

            <TextField
              theme="3"
              input-type="decimal"
              :disabled="tempBudget.have_budget_detail"
              :readonly="tempBudget.have_budget_detail"
              :value="tempBudget.actual_amount"
              isFormat
              @onChange="tempBudget.actual_amount = $event"
            ></TextField>
          </div>

          <div>
            <div class="black--text mb-3">กรอบวงเงินงบประมาณ(บาท)</div>

            <TextField
              theme="3"
              input-type="decimal"
              :disabled="tempBudget.have_budget_detail"
              :readonly="tempBudget.have_budget_detail"
              :value="tempBudget.budget_amount_rsp"
              isFormat
              @onChange="tempBudget.budget_amount_rsp = $event"
            ></TextField>
          </div>

          <div class="d-flex align-center gap-12">
            <div class="mb-1 pt-1 black--text">รายละเอียด</div>
            <SwitchInset
              :input-value="tempBudget.have_budget_detail"
              :true-value="true"
              :false-value="false"
              @onChange="budgetHasDetail"
            ></SwitchInset>
            <div>{{ tempBudget.have_budget_detail ? "มี" : "ไม่มี" }}</div>
          </div>
        </div>

        <div v-if="tempBudget.have_budget_detail">
          <div class="black--text mb-3">รายละเอียด</div>

          <div class="d-flex flex-column gap-12">
            <div
              v-for="(item, i) in tempBudget.form_fund_budget_detail"
              :key="i"
              class="d-flex align-center gap-16"
            >
              <div>
                <div class="black--text mb-3">ข้อที่ {{ i + 1 }}</div>

                <TextField
                  theme="3"
                  style="width: 400px"
                  :value="item.budget_detail_name"
                  @onChange="item.budget_detail_name = $event"
                ></TextField>
              </div>

              <div>
                <div class="black--text mb-3">ค่าใช้จ่ายจริง (บาท)</div>

                <TextField
                  theme="3"
                  input-type="decimal"
                  :value="item.actual_detail_amount"
                  isFormat
                  @onChange="editDetailActualAmount(i, $event)"
                ></TextField>
              </div>

              <div>
                <div class="black--text mb-3">กรอบวงเงินงบประมาณ(บาท)</div>

                <TextField
                  theme="3"
                  input-type="decimal"
                  isFormat
                  :value="item.budget_detail_amount"
                  @onChange="editDetailAmount(i, $event)"
                ></TextField>
              </div>

              <v-btn
                v-if="tempBudget.form_fund_budget_detail.length > 1"
                icon
                x-small
                style="background: var(--theme-color-seven)"
                class="mt-1"
                @click="
                  tempBudget.form_fund_budget_detail.splice(i, 1);
                  this.calTempBudgetAmountFromSub();
                "
              >
                <span class="font-type-bold txt-detail white--text pb-1"
                  >x</span
                >
              </v-btn>

              <v-btn
                v-if="i + 1 === tempBudget.form_fund_budget_detail.length"
                icon
                x-small
                style="background: var(--theme-color-two)"
                class="mt-1"
                @click="addBudgetDetail"
              >
                <span class="font-type-bold txt-detail white--text">+</span>
              </v-btn>
            </div>
          </div>
        </div>

        <div class="d-flex justify-end gap-16">
          <Button min-width="80px" theme="2" @onClick="partTwoEditMode = false"
            >ยกเลิก
          </Button>

          <Button min-width="80px" theme="6" @onClick="saveBudget"
            >ยืนยัน
          </Button>
        </div>
      </div>
    </divcard>
    <!-- section 2 -->
    <divcard>
      <div class="txt-head black--text mb-2">
        2.  สถานะการดำเนินโครงการ 
      </div>
      <div class="flex xs4 mb-2">
        <div class="txt-normal mb-1 black--text">สถานะ</div>
      </div>
      <v-radio-group
          class="mt-0 pt-0"
          :value="form.project_status"
          @change="setFormField('project_status', $event)"
      >
            <div class="flex">
              <RadioItem class="mb-3" value="progress">
                <div class="black--text">
                  อยู่ระหว่างดำเนินการ
                </div>
              </RadioItem>
              <RadioItem class="mb-3" value="done">
                <div class="black--text">
                  ดำเนินโครงการแล้วเสร็จ
                </div>
              </RadioItem>
              <RadioItem class="mb-3" value="other">
                <div class="black--text">
                  อื่นๆ (ระบุ)
              </div>
              </RadioItem>
                <div class="flex xs6">
                  <TextField
                      theme="3"
                      :value="tempProjectOther"
                      :disabled="form.project_status != 'other'"
                      :readonly="form.project_status != 'other'"
                      @onChange="tempProjectOther = $event"
                  ></TextField>
              </div>
            </div>
      </v-radio-group>
    </divcard>
  </div>
</template>

<script>
import TextField from "../../../components/input/TextField";
import TextArea from "../../../components/input/TextArea";
import SwitchInset from "../../../components/input/SwitchInset";
import AutoBox from "../../../components/input/AutoBox";
import Button from "../../../components/input/Button";
import CheckBox from "../../../components/input/CheckBox";
import { eventBus, formatNumber } from "../../../plugins/global-funcs";
import { mapState } from "vuex";
import { format } from "date-fns";
import { th } from "date-fns/locale";
import SelectBox from "@/components/input/SelectBox";
import RadioItem from "@/components/input/RadioItem";

export default {
  name: "FundamentalFormApprovedCredit",
  components: {
    TextField,
    TextArea,
    SwitchInset,
    AutoBox,
    CheckBox,
    Button,
    SelectBox,
    RadioItem
  },
  props: {
    masterData: {
      default: () => ({}),
    },
    isSameId: {
      default: false,
    },
  },
  data() {
    return {
      formatNumber,
      form: {},
      tempProjectOther: "",
      tempBudgetPlan: {},
      tempBudget: {
        form_fund_budget_detail: [],
      },
      partTwoEditMode: false,
      expanded: false,
      budgetPlans: [],
      allProgressPlan: [],
      budgetList: [],
      budget_amount: 0,
    };
  },
  computed: {
    ...mapState({
      PlanForm: (state) => state.AForm.PlanForm,
    }),
    isFinal() {
      return (
        this.$route.query.doc_type && this.$route.query.doc_type === "progress"
      );
    },
  },
  created() {
    if (this.masterData.formFund) {
      this.setData();
    }

    eventBus.$on("fundamentalFormApprovedCredit", () => {
      this.form.project_status = this.form.project_status == 'other' ? this.tempProjectOther : this.form.project_status;
      eventBus.$emit("fundamentalFormApprovedCreditSend", {
        ...this.form,
        form_fund_budget: this.budgetList.map((x) => ({
          id: x.id,
          budget_name: x.budget_name,
          net_fund_budget: Number(formatNumber(x.budget_amount_rsp, 2).replace(/,/g, '')),
          actual_amount: Number(formatNumber(x.actual_amount, 2).replace(/,/g, '')),
          form_fund_budget_detail: x.form_fund_budget_detail.map((detail) => ({
            id: detail.id,
            budget_detail_name: detail.budget_detail_name,
            budget_detail_amount: Number(formatNumber(detail.budget_detail_amount, 2).replace(/,/g, '')),
            actual_detail_amount: Number(formatNumber(detail.actual_detail_amount, 2).replace(/,/g, '')),
          })) || [],
        })),
      });
    });

    eventBus.$on("fundamentalFormApprovedCreditSetData", () => this.setData());
  },
  methods: {
    setFormField(field, val) {
      this.form[field] = val;
      this.$forceUpdate();
    },
    setData() {
      console.log("setData formFund in ap credit", this.masterData.formFund);
      this.budgetList = this.masterData.formFund?.form_fund_budgets?.map((x) => ({
        id: x.id,
        budget_name: x.budget_name,
        form_fund_budget_detail: x.form_fund_budget_detail || [],
        budget_amount_rsp: x.net_fund_budget || 0,
        actual_amount: x.actual_amount || 0,
        have_budget_detail: x.form_fund_budget_detail && x.form_fund_budget_detail.length > 0,
      })) || [];
      this.form.project_status =
        this.masterData.formFund?.project_status;
      this.calcBudgetAmount();
      this.checkProjectStatus();
    },
    removeVModel(item) {
      return JSON.parse(JSON.stringify(item));
    },
    getLastProgress(items) {
      items = this.removeVModel(items);
      if (items && typeof items === "object" && items.length > 0) {
        for (const x of items.reverse()) {
          if (!!x.month_value && x.month_value !== "-") {
            return x.month_value;
          }
        }
      }
      return "-";
    },
    addNewBudget() {
      this.tempBudget = {
        form_fund_budget_detail: [],
      };
      if (this.partTwoEditMode) {
        // clear temp index

        this.$vuetify.goTo("#part-two-edit");
      } else {
        // this.tempPlan.isNew = true
        this.partTwoEditMode = true;
      }
    },
    editBudget(index) {
      this.tempBudget = {
        ...this.removeVModel(this.budgetList[index]),
        temp_index: index,
      };
      this.tempBudget.have_budget_detail =
        this.tempBudget.form_fund_budget_detail.length > 0;
      this.partTwoEditMode = true;
    },
    deleteBudget(index) {
      this.budgetList.splice(index, 1);
      this.calcBudgetAmount();
      this.calcBudgetPlanRate("budgetPlans");
    },
    saveBudget() {
      this.partTwoEditMode = false;
      //this.tempBudget.budget_sum = parseFloat(this.tempBudget.budget_in_kind) + parseFloat(this.tempBudget.budget_in_cash) + parseFloat(this.tempBudget.budget_sci_park)
      if (isNaN(this.tempBudget.budget_amount_rsp))
        this.tempBudget.budget_amount_rsp = 0;
      if (!this.tempBudget.have_budget_detail)
        this.tempBudget.form_fund_budget_detail = [];
      if (this.tempBudget.temp_index !== undefined) {
        this.budgetList[this.tempBudget.temp_index] = this.removeVModel(
          this.tempBudget
        );
      } else {
        this.budgetList.push(this.tempBudget);
      }
      this.tempBudget = {};

      this.calcBudgetAmount();
      this.calcBudgetPlanRate("budgetPlans");
      this.$forceUpdate();
    },
    addBudgetDetail() {
      this.tempBudget.form_fund_budget_detail.push({});
    },
    budgetHasDetail(val) {
      this.tempBudget.budget_amount_rsp = undefined;
      this.tempBudget.have_budget_detail = val;
      this.$forceUpdate();
      if (
        !this.tempBudget.form_fund_budget_detail ||
        this.tempBudget.form_fund_budget_detail.length === 0
      ) {
        this.tempBudget.form_fund_budget_detail = [];
        this.addBudgetDetail();
      }
    },
    editDetailAmount(i, val) {
      this.tempBudget.form_fund_budget_detail[i].budget_detail_amount = val;
      this.calTempBudgetAmountFromSub();
    },
    editDetailActualAmount(i, val) {
      this.tempBudget.form_fund_budget_detail[i].actual_detail_amount = val;
      this.calTempBudgetAmountFromSub();
    },
    calTempBudgetAmountFromSub() {
      this.tempBudget.budget_amount_rsp = this.tempBudget.form_fund_budget_detail
        .map((x) => x.budget_detail_amount)
        .reduce((a, b) => parseFloat(a) + parseFloat(b), 0);

      this.tempBudget.actual_amount = this.tempBudget.form_fund_budget_detail
        .map((x) => x.actual_detail_amount)
        .reduce((a, b) => parseFloat(a) + parseFloat(b), 0);

      this.$forceUpdate();
    },
    calcBudgetAmount() {
      // console.log("budget", this.budgetList);
      this.budget_amount = this.budgetList
        .map((x) => parseFloat(x.budget_amount_rsp))
        .reduce((a, b) => a + b, 0);
      // console.log("budget_amount", this.budget_amount);
    },
    calcBudgetPlanRate(objectName = "tempBudgetPlan") {
      let i = 0;
      let field_name =
        this.isFinal && objectName === "tempBudgetPlan"
          ? "use_budget"
          : "plan_budget";
      this[objectName].forEach((budget) => {
        if (!budget[field_name]) budget[field_name] = 0;
        if (i == 0) {
          budget[field_name + "_sum"] = parseFloat(budget[field_name]);
        } else {
          budget[field_name + "_sum"] =
            parseFloat(budget[field_name]) +
            parseFloat(this[objectName][i - 1][field_name + "_sum"]);
        }
        const exactRate = (parseFloat(budget[field_name + "_sum"]) / parseFloat(this.budget_amount)) * 100;

        budget[field_name + "_rate"] = (Math.floor(exactRate * 100) / 100).toFixed(2);
        budget[field_name + "_sum"] = budget[field_name + "_sum"].toFixed(2);
        i++;
      });
      console.log("after calc budget rate", this.tempBudgetPlan);
    },
    checkProjectStatus() {
      if(!this.form.project_status) {
        this.form.project_status = null;
        this.tempProjectOther = null;
        return;
      }


      if (this.form.project_status === "done") {
        this.form.project_status = "done";
      } else if (this.form.project_status === "progress") {
        this.form.project_status = "progress";
      } else {
        this.tempProjectOther = this.form.project_status;
        this.form.project_status = "other";
      }
    },
  },
};
</script>

<style scoped lang="scss">
.budget-item,
.summary-plan {
  background: #ffffff;
  box-shadow: 1px 1px 30px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  padding: 12px;
  border: solid 1px transparent;
  cursor: pointer;
}

.budget-item-active {
  border-color: var(--theme-color-seven);
}

.summary-plan {
  min-height: 78px;
}

.remark-box {
  color: var(--theme-color-seven);
  background: #fafafa;
  border-radius: 20px;
  padding: 12px;
  font-size: 10px;
}

.plan-card {
  background: #ffffff;
  box-shadow: 1px 1px 18px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  border: 1px solid transparent;
  padding: 12px;
  min-width: max-content;
  &.plan-active {
    border: 1px solid var(--theme-color-seven);
  }
}

.plan-field-form {
  /* User input values. */
  --grid-layout-gap: 16px;
  --grid-column-count: 6;
  --grid-item--min-width: 130px;

  /* Calculated values. */
  --gap-count: calc(var(--grid-column-count) - 1);
  --total-gap-width: calc(var(--gap-count) * var(--grid-layout-gap));
  --grid-item--max-width: calc(
    (100% - var(--total-gap-width)) / var(--grid-column-count)
  );

  display: grid;
  grid-template-columns: repeat(
    auto-fill,
    minmax(max(var(--grid-item--min-width), var(--grid-item--max-width)), 1fr)
  );
  grid-gap: var(--grid-layout-gap);
}

.plan-slot > div {
  transition: background-color 400ms;
  background-color: #fff;
  height: 20px;
}
.plan-slot .progress-plan-mark {
  background-color: var(--theme-color-one);
  min-width: 45px;
  display: flex;
  align-items: center;
  padding-top: 1px;
  .v-divider {
    border-color: #fff;
  }
}

.progress-plan-mark.start-point {
  border-radius: 30px 0 0 30px;
  padding-left: 4px;
}

.progress-plan-mark.end-point {
  border-radius: 0 30px 30px 0;
  padding-right: 6px;
}

.arrow-right {
  display: none;
}
.end-point .arrow-right {
  display: unset;
  font-family: "Tahoma", sans-serif;
  margin-left: -8px;
  margin-top: -3px;
  user-select: none;
}
</style>
